export const PROMOTE_CODE = 'PROMOTE_CODE'
export const INSIDE_APPID = 'INSIDE_APPID'
export const DY_AUTH_CB = 'DY_AUTH_CB'
export const DY_AUTH_CB_QP = 'DY_AUTH_CB_QP'
